import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import '../styles/PrivacyDialog.css';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

// Added onDecline prop
const PrivacyDialog = ({ open, onAccept, onDecline }) => {
  const navigate = useNavigate();

  const handlePrivacyPolicyClick = () => {
    navigate('/privacy-policy'); // Navigate to the privacy policy page
  };

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Privacy & Consent Notice</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          This website uses cookies and similar technologies to enhance your experience, analyze site usage, and for security purposes. By clicking "Accept", you consent to the use of these technologies as described in our Privacy Policy. If you choose to "Decline", only strictly necessary cookies will be used. You have the right to withdraw your consent at any time.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          For more information, please review our{' '}
          <span
            onClick={handlePrivacyPolicyClick}
            style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
          >
            Privacy Policy
          </span>.
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          This notice is provided in accordance with the General Data Protection Regulation (GDPR) and other applicable privacy laws. You may request access to, correction, or deletion of your personal data at any time.
        </Typography>
      </DialogContent>
      <DialogActions className="privacy-dialog-actions">
        {/* Added the Decline button */}
        <Button onClick={onDecline} className="privacy-decline-btn" variant="contained">
          Decline
        </Button>
        <Button onClick={onAccept} variant="contained" color="primary">
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyDialog;